import React, { useState } from 'react';
import CameraCapture from './CameraCapture';
import PostCreation from './PostCreation';

interface ContentCreationFlowProps {
  onClose: () => void;
}

type FlowStep = 'camera' | 'post';

const ContentCreationFlow: React.FC<ContentCreationFlowProps> = ({ onClose }) => {
  const [currentStep, setCurrentStep] = useState<FlowStep>('camera');
  const [capturedMedia, setCapturedMedia] = useState<File[]>([]);

  const handleMediaCapture = (files: File[]) => {
    setCapturedMedia(files);
    setCurrentStep('post');
  };

  const handleBackToCamera = () => {
    setCurrentStep('camera');
  };

  return (
    <>
      {currentStep === 'camera' && (
        <CameraCapture
          onClose={onClose}
          onCapture={handleMediaCapture}
        />
      )}
      
      {currentStep === 'post' && (
        <PostCreation
          mediaFiles={capturedMedia}
          onClose={onClose}
          onBack={handleBackToCamera}
        />
      )}
    </>
  );
};

export default ContentCreationFlow;